import styled from 'styled-components';

export const ApplyButton = styled.button`
  padding: 9px 12px;
  border-radius: 8px;
  border: 0;
  background: ${({ theme }) => theme.colors.blue700 || '#2f6feb'};
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.92;
  }
`;
